import * as React from 'react';
import { Flex, Heading, Tooltip } from "../..";
import { Icon } from "../../icon";
import { _getLabelStyles } from "./StandardLabel.styles";
var sizeHeadingSizeMapping = {
  large: 'regular',
  medium: 'regular',
  small: 'intermediate',
  tiny: 'small'
};

var StandardLabel = function StandardLabel(_ref) {
  var size = _ref.size,
      label = _ref.label,
      info = _ref.info;

  var labelStyles = _getLabelStyles({
    size: size
  });

  return /*#__PURE__*/React.createElement(Flex, {
    alignItems: "center",
    sx: labelStyles
  }, /*#__PURE__*/React.createElement(Heading, {
    size: sizeHeadingSizeMapping[size],
    pr: 1
  }, label), info && /*#__PURE__*/React.createElement(Tooltip, {
    tooltip: info,
    placement: "right"
  }, /*#__PURE__*/React.createElement(Icon, {
    icon: "information",
    size: "small",
    color: "grey.600"
  })));
};

export default StandardLabel;